// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"fa15627b","648":"fa15627b","925":"fa15627b"}[chunkId] + ".chunk.css";
};